
(function () {
  'use strict';
  if (window.BNBusy) return;

  var LABEL_CLASS = 'bn-busy__label';
  var IND_CLASS = 'bn-busy__ind';
  var CAP_CLASS = 'bn-busy__cap';

  function bnDir(el) { return getComputedStyle(el || document.documentElement).direction === 'rtl' ? -1 : 1; }

  function isBusy(el) {
    return !!(el && el.getAttribute && el.getAttribute('data-bn-busy') === '1');
  }

  function ownChild(el, cls) {
    if (!el) return null;
    for (var i = 0; i < el.children.length; i++) {
      if (el.children[i].classList.contains(cls)) return el.children[i];
    }
    return null;
  }

  function makeCaption(text) {
    var cap = document.createElement('span');
    cap.className = CAP_CLASS;
    if (bnDir() === -1) cap.dir = 'auto';
    cap.textContent = text;
    return cap;
  }

  function setCaption(el, text) {
    if (!isBusy(el)) return;
    var ind = ownChild(el, IND_CLASS);
    if (!ind) return;
    var cap = ind.querySelector('.' + CAP_CLASS);
    if (!text) { if (cap) ind.removeChild(cap); return; }
    if (cap) cap.textContent = text;
    else ind.appendChild(makeCaption(text));
  }

  function on(el, caption, opts) {
    if (!el) return;
    if (isBusy(el)) { setCaption(el, caption); return; }

    try {
      if (el.offsetWidth && !el.style.minWidth) {
        el.style.minWidth = el.offsetWidth + 'px';
        el.setAttribute('data-bn-busy-w', '1');
      }
      if (el.offsetHeight && !el.style.minHeight) {
        el.style.minHeight = el.offsetHeight + 'px';
        el.setAttribute('data-bn-busy-h', '1');
      }
    } catch (e) {}

    var label = document.createElement('span');
    label.className = LABEL_CLASS;
    while (el.firstChild) label.appendChild(el.firstChild);
    el.appendChild(label);

    var ind = document.createElement('span');
    ind.className = IND_CLASS;
    var wantsDots = !!(opts && opts.dots);
    var mark = document.createElement('span');
    mark.className = wantsDots ? 'bn-busy__dots' : 'bn-busy__ring';
    mark.setAttribute('aria-hidden', 'true');
    if (wantsDots) mark.innerHTML = '<i></i><i></i><i></i>';
    ind.appendChild(mark);
    if (caption && !wantsDots) ind.appendChild(makeCaption(caption));
    el.appendChild(ind);

    el.setAttribute('data-bn-busy', '1');
    el.setAttribute('aria-busy', 'true');
    el.classList.add('bn-busy');

    if ('disabled' in el) {
      el.setAttribute('data-bn-busy-dis', el.disabled ? '1' : '0');
      el.disabled = true;
    } else {
      el.setAttribute('aria-disabled', 'true');
    }
  }

  function off(el) {
    if (!el) return;
    var wasBusy = isBusy(el);

    var ind = ownChild(el, IND_CLASS);
    if (ind) el.removeChild(ind);

    var label = ownChild(el, LABEL_CLASS);
    if (label) {
      while (label.firstChild) el.insertBefore(label.firstChild, label);
      el.removeChild(label);
    }

    if (el.getAttribute('data-bn-busy-w') === '1') {
      el.style.minWidth = '';
      el.removeAttribute('data-bn-busy-w');
    }
    if (el.getAttribute('data-bn-busy-h') === '1') {
      el.style.minHeight = '';
      el.removeAttribute('data-bn-busy-h');
    }

    if (el.hasAttribute('data-bn-busy-dis')) {
      if ('disabled' in el) el.disabled = el.getAttribute('data-bn-busy-dis') === '1';
      el.removeAttribute('data-bn-busy-dis');
    } else if (wasBusy && !('disabled' in el)) {
      el.removeAttribute('aria-disabled');
    }

    el.removeAttribute('data-bn-busy');
    if (wasBusy) el.removeAttribute('aria-busy');
    el.classList.remove('bn-busy');
  }

  function done(el, ms) {
    if (!el) return;
    off(el);
    var mark = document.createElement('span');
    mark.className = 'bn-busy__tick';
    mark.setAttribute('aria-hidden', 'true');
    mark.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4.5 4.5L19 7"/></svg>';

    var label = document.createElement('span');
    label.className = LABEL_CLASS;
    while (el.firstChild) label.appendChild(el.firstChild);
    el.appendChild(label);
    el.appendChild(mark);
    el.classList.add('bn-busy-done');

    setTimeout(function () {
      if (!el.classList.contains('bn-busy-done')) return;
      if (mark.parentNode === el) el.removeChild(mark);
      if (label.parentNode === el) {
        while (label.firstChild) el.insertBefore(label.firstChild, label);
        el.removeChild(label);
      }
      el.classList.remove('bn-busy-done');
    }, typeof ms === 'number' ? ms : 1100);
  }

  window.BNBusy = { on: on, off: off, done: done, caption: setCaption, is: isBusy };
}());
